"use strict";

var e,
    t = require("./index-7ebd9a2e.js"),
    n = require("react"),
    r = (e = n) && "object" == typeof e && "default" in e ? e.default : e;

function a(e) {
  if (null === e || !0 === e || !1 === e) return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}

function o(e, t) {
  if (t.length < e) throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}

function i(e) {
  o(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || "object" == typeof e && "[object Date]" === t ? new Date(e.getTime()) : "number" == typeof e || "[object Number]" === t ? new Date(e) : ("string" != typeof e && "[object String]" !== t || "undefined" == typeof console || (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"), console.warn(new Error().stack)), new Date(NaN));
}

function u(e, t) {
  o(2, arguments);
  var n = i(e),
      r = a(t);
  return isNaN(r) ? new Date(NaN) : r ? (n.setDate(n.getDate() + r), n) : n;
}

function s(e, t) {
  o(2, arguments);
  var n = i(e),
      r = a(t);
  if (isNaN(r)) return new Date(NaN);
  if (!r) return n;
  var u = n.getDate(),
      s = new Date(n.getTime());
  s.setMonth(n.getMonth() + r + 1, 0);
  var c = s.getDate();
  return u >= c ? s : (n.setFullYear(s.getFullYear(), s.getMonth(), u), n);
}

function c(e, t) {
  o(2, arguments);
  var n = i(e).getTime(),
      r = a(t);
  return new Date(n + r);
}

function d(e, t) {
  o(1, arguments);
  var n = t || {},
      r = n.locale,
      u = r && r.options && r.options.weekStartsOn,
      s = null == u ? 0 : a(u),
      c = null == n.weekStartsOn ? s : a(n.weekStartsOn);
  if (!(c >= 0 && c <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var d = i(e),
      l = d.getDay(),
      f = (l < c ? 7 : 0) + l - c;
  return d.setDate(d.getDate() - f), d.setHours(0, 0, 0, 0), d;
}

function l(e) {
  return e.getTime() % 6e4;
}

function f(e) {
  var t = new Date(e.getTime()),
      n = Math.ceil(t.getTimezoneOffset());
  return t.setSeconds(0, 0), 6e4 * n + (n > 0 ? (6e4 + l(t)) % 6e4 : l(t));
}

function h(e) {
  o(1, arguments);
  var t = i(e);
  return t.setHours(0, 0, 0, 0), t;
}

function m(e, t) {
  o(2, arguments);
  var n = h(e),
      r = h(t),
      a = n.getTime() - f(n),
      i = r.getTime() - f(r);
  return Math.round((a - i) / 864e5);
}

function g(e, t) {
  o(2, arguments);
  var n = i(e),
      r = i(t),
      a = n.getTime() - r.getTime();
  return a < 0 ? -1 : a > 0 ? 1 : a;
}

function v(e) {
  o(1, arguments);
  var t = i(e);
  return !isNaN(t);
}

function w(e, t) {
  o(2, arguments);
  var n = h(e),
      r = h(t);
  return n.getTime() === r.getTime();
}

function b(e, t) {
  o(2, arguments);
  var n = i(e),
      r = i(t),
      a = n.getFullYear() - r.getFullYear(),
      u = n.getMonth() - r.getMonth();
  return 12 * a + u;
}

function y(e, t, n) {
  o(2, arguments);
  var r = d(e, n),
      a = d(t, n),
      i = r.getTime() - f(r),
      u = a.getTime() - f(a);
  return Math.round((i - u) / 6048e5);
}

function p(e, t) {
  var n = e.getFullYear() - t.getFullYear() || e.getMonth() - t.getMonth() || e.getDate() - t.getDate() || e.getHours() - t.getHours() || e.getMinutes() - t.getMinutes() || e.getSeconds() - t.getSeconds() || e.getMilliseconds() - t.getMilliseconds();
  return n < 0 ? -1 : n > 0 ? 1 : n;
}

function k(e, t) {
  o(2, arguments);
  var n = i(e),
      r = i(t),
      a = p(n, r),
      u = Math.abs(m(n, r));
  n.setDate(n.getDate() - a * u);
  var s = p(n, r) === -a,
      c = a * (u - s);
  return 0 === c ? 0 : c;
}

function M(e) {
  o(1, arguments);
  var t = i(e);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}

function T(e) {
  o(1, arguments);
  var t = i(e),
      n = t.getMonth();
  return t.setFullYear(t.getFullYear(), n + 1, 0), t.setHours(23, 59, 59, 999), t;
}

var N = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
};

function D(e) {
  return function (t) {
    var n = t || {},
        r = n.width ? String(n.width) : e.defaultWidth;
    return e.formats[r] || e.formats[e.defaultWidth];
  };
}

var C = {
  date: D({
    formats: {
      full: "EEEE, MMMM do, y",
      long: "MMMM do, y",
      medium: "MMM d, y",
      short: "MM/dd/yyyy"
    },
    defaultWidth: "full"
  }),
  time: D({
    formats: {
      full: "h:mm:ss a zzzz",
      long: "h:mm:ss a z",
      medium: "h:mm:ss a",
      short: "h:mm a"
    },
    defaultWidth: "full"
  }),
  dateTime: D({
    formats: {
      full: "{{date}} 'at' {{time}}",
      long: "{{date}} 'at' {{time}}",
      medium: "{{date}}, {{time}}",
      short: "{{date}}, {{time}}"
    },
    defaultWidth: "full"
  })
},
    P = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
};

function x(e) {
  return function (t, n) {
    var r,
        a = n || {};

    if ("formatting" === (a.context ? String(a.context) : "standalone") && e.formattingValues) {
      var o = e.defaultFormattingWidth || e.defaultWidth,
          i = a.width ? String(a.width) : o;
      r = e.formattingValues[i] || e.formattingValues[o];
    } else {
      var u = e.defaultWidth,
          s = a.width ? String(a.width) : e.defaultWidth;
      r = e.values[s] || e.values[u];
    }

    return r[e.argumentCallback ? e.argumentCallback(t) : t];
  };
}

function W(e) {
  return function (t, n) {
    var r = String(t),
        a = n || {},
        o = a.width,
        i = o && e.matchPatterns[o] || e.matchPatterns[e.defaultMatchWidth],
        u = r.match(i);
    if (!u) return null;
    var s,
        c = u[0],
        d = o && e.parsePatterns[o] || e.parsePatterns[e.defaultParseWidth];
    return s = "[object Array]" === Object.prototype.toString.call(d) ? function (e, t) {
      for (var n = 0; n < e.length; n++) {
        if (t(e[n])) return n;
      }
    }(d, function (e) {
      return e.test(c);
    }) : function (e, t) {
      for (var n in e) {
        if (e.hasOwnProperty(n) && t(e[n])) return n;
      }
    }(d, function (e) {
      return e.test(c);
    }), s = e.valueCallback ? e.valueCallback(s) : s, {
      value: s = a.valueCallback ? a.valueCallback(s) : s,
      rest: r.slice(c.length)
    };
  };
}

var S,
    E = {
  code: "en-US",
  formatDistance: function formatDistance(e, t, n) {
    var r;
    return n = n || {}, r = "string" == typeof N[e] ? N[e] : 1 === t ? N[e].one : N[e].other.replace("{{count}}", t), n.addSuffix ? n.comparison > 0 ? "in " + r : r + " ago" : r;
  },
  formatLong: C,
  formatRelative: function formatRelative(e, t, n, r) {
    return P[e];
  },
  localize: {
    ordinalNumber: function ordinalNumber(e, t) {
      var n = Number(e),
          r = n % 100;
      if (r > 20 || r < 10) switch (r % 10) {
        case 1:
          return n + "st";

        case 2:
          return n + "nd";

        case 3:
          return n + "rd";
      }
      return n + "th";
    },
    era: x({
      values: {
        narrow: ["B", "A"],
        abbreviated: ["BC", "AD"],
        wide: ["Before Christ", "Anno Domini"]
      },
      defaultWidth: "wide"
    }),
    quarter: x({
      values: {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["Q1", "Q2", "Q3", "Q4"],
        wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
      },
      defaultWidth: "wide",
      argumentCallback: function argumentCallback(e) {
        return Number(e) - 1;
      }
    }),
    month: x({
      values: {
        narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
        abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
      },
      defaultWidth: "wide"
    }),
    day: x({
      values: {
        narrow: ["S", "M", "T", "W", "T", "F", "S"],
        short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
        abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
      },
      defaultWidth: "wide"
    }),
    dayPeriod: x({
      values: {
        narrow: {
          am: "a",
          pm: "p",
          midnight: "mi",
          noon: "n",
          morning: "morning",
          afternoon: "afternoon",
          evening: "evening",
          night: "night"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "midnight",
          noon: "noon",
          morning: "morning",
          afternoon: "afternoon",
          evening: "evening",
          night: "night"
        },
        wide: {
          am: "a.m.",
          pm: "p.m.",
          midnight: "midnight",
          noon: "noon",
          morning: "morning",
          afternoon: "afternoon",
          evening: "evening",
          night: "night"
        }
      },
      defaultWidth: "wide",
      formattingValues: {
        narrow: {
          am: "a",
          pm: "p",
          midnight: "mi",
          noon: "n",
          morning: "in the morning",
          afternoon: "in the afternoon",
          evening: "in the evening",
          night: "at night"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "midnight",
          noon: "noon",
          morning: "in the morning",
          afternoon: "in the afternoon",
          evening: "in the evening",
          night: "at night"
        },
        wide: {
          am: "a.m.",
          pm: "p.m.",
          midnight: "midnight",
          noon: "noon",
          morning: "in the morning",
          afternoon: "in the afternoon",
          evening: "in the evening",
          night: "at night"
        }
      },
      defaultFormattingWidth: "wide"
    })
  },
  match: {
    ordinalNumber: (S = {
      matchPattern: /^(\d+)(th|st|nd|rd)?/i,
      parsePattern: /\d+/i,
      valueCallback: function valueCallback(e) {
        return parseInt(e, 10);
      }
    }, function (e, t) {
      var n = String(e),
          r = t || {},
          a = n.match(S.matchPattern);
      if (!a) return null;
      var o = a[0],
          i = n.match(S.parsePattern);
      if (!i) return null;
      var u = S.valueCallback ? S.valueCallback(i[0]) : i[0];
      return {
        value: u = r.valueCallback ? r.valueCallback(u) : u,
        rest: n.slice(o.length)
      };
    }),
    era: W({
      matchPatterns: {
        narrow: /^(b|a)/i,
        abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
        wide: /^(before christ|before common era|anno domini|common era)/i
      },
      defaultMatchWidth: "wide",
      parsePatterns: {
        any: [/^b/i, /^(a|c)/i]
      },
      defaultParseWidth: "any"
    }),
    quarter: W({
      matchPatterns: {
        narrow: /^[1234]/i,
        abbreviated: /^q[1234]/i,
        wide: /^[1234](th|st|nd|rd)? quarter/i
      },
      defaultMatchWidth: "wide",
      parsePatterns: {
        any: [/1/i, /2/i, /3/i, /4/i]
      },
      defaultParseWidth: "any",
      valueCallback: function valueCallback(e) {
        return e + 1;
      }
    }),
    month: W({
      matchPatterns: {
        narrow: /^[jfmasond]/i,
        abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
        wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
      },
      defaultMatchWidth: "wide",
      parsePatterns: {
        narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
        any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
      },
      defaultParseWidth: "any"
    }),
    day: W({
      matchPatterns: {
        narrow: /^[smtwf]/i,
        short: /^(su|mo|tu|we|th|fr|sa)/i,
        abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
        wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
      },
      defaultMatchWidth: "wide",
      parsePatterns: {
        narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
        any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
      },
      defaultParseWidth: "any"
    }),
    dayPeriod: W({
      matchPatterns: {
        narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
        any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
      },
      defaultMatchWidth: "any",
      parsePatterns: {
        any: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /^mi/i,
          noon: /^no/i,
          morning: /morning/i,
          afternoon: /afternoon/i,
          evening: /evening/i,
          night: /night/i
        }
      },
      defaultParseWidth: "any"
    })
  },
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};

function O(e, t) {
  o(2, arguments);
  var n = a(t);
  return c(e, -n);
}

function U(e, t) {
  for (var n = e < 0 ? "-" : "", r = Math.abs(e).toString(); r.length < t;) {
    r = "0" + r;
  }

  return n + r;
}

var Y = function Y(e, t) {
  var n = e.getUTCFullYear(),
      r = n > 0 ? n : 1 - n;
  return U("yy" === t ? r % 100 : r, t.length);
},
    j = function j(e, t) {
  var n = e.getUTCMonth();
  return "M" === t ? String(n + 1) : U(n + 1, 2);
},
    F = function F(e, t) {
  return U(e.getUTCDate(), t.length);
},
    q = function q(e, t) {
  return U(e.getUTCHours() % 12 || 12, t.length);
},
    _H = function H(e, t) {
  return U(e.getUTCHours(), t.length);
},
    _ = function _(e, t) {
  return U(e.getUTCMinutes(), t.length);
},
    L = function L(e, t) {
  return U(e.getUTCSeconds(), t.length);
},
    z = function z(e, t) {
  var n = t.length,
      r = e.getUTCMilliseconds();
  return U(Math.floor(r * Math.pow(10, n - 3)), t.length);
};

function X(e) {
  o(1, arguments);
  var t = 1,
      n = i(e),
      r = n.getUTCDay(),
      a = (r < t ? 7 : 0) + r - t;
  return n.setUTCDate(n.getUTCDate() - a), n.setUTCHours(0, 0, 0, 0), n;
}

function B(e) {
  o(1, arguments);
  var t = i(e),
      n = t.getUTCFullYear(),
      r = new Date(0);
  r.setUTCFullYear(n + 1, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var a = X(r),
      u = new Date(0);
  u.setUTCFullYear(n, 0, 4), u.setUTCHours(0, 0, 0, 0);
  var s = X(u);
  return t.getTime() >= a.getTime() ? n + 1 : t.getTime() >= s.getTime() ? n : n - 1;
}

function Q(e) {
  o(1, arguments);
  var t = B(e),
      n = new Date(0);
  n.setUTCFullYear(t, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var r = X(n);
  return r;
}

function A(e, t) {
  o(1, arguments);
  var n = t || {},
      r = n.locale,
      u = r && r.options && r.options.weekStartsOn,
      s = null == u ? 0 : a(u),
      c = null == n.weekStartsOn ? s : a(n.weekStartsOn);
  if (!(c >= 0 && c <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var d = i(e),
      l = d.getUTCDay(),
      f = (l < c ? 7 : 0) + l - c;
  return d.setUTCDate(d.getUTCDate() - f), d.setUTCHours(0, 0, 0, 0), d;
}

function G(e, t) {
  o(1, arguments);
  var n = i(e, t),
      r = n.getUTCFullYear(),
      u = t || {},
      s = u.locale,
      c = s && s.options && s.options.firstWeekContainsDate,
      d = null == c ? 1 : a(c),
      l = null == u.firstWeekContainsDate ? d : a(u.firstWeekContainsDate);
  if (!(l >= 1 && l <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var f = new Date(0);
  f.setUTCFullYear(r + 1, 0, l), f.setUTCHours(0, 0, 0, 0);
  var h = A(f, t),
      m = new Date(0);
  m.setUTCFullYear(r, 0, l), m.setUTCHours(0, 0, 0, 0);
  var g = A(m, t);
  return n.getTime() >= h.getTime() ? r + 1 : n.getTime() >= g.getTime() ? r : r - 1;
}

function R(e, t) {
  o(1, arguments);
  var n = t || {},
      r = n.locale,
      i = r && r.options && r.options.firstWeekContainsDate,
      u = null == i ? 1 : a(i),
      s = null == n.firstWeekContainsDate ? u : a(n.firstWeekContainsDate),
      c = G(e, t),
      d = new Date(0);
  d.setUTCFullYear(c, 0, s), d.setUTCHours(0, 0, 0, 0);
  var l = A(d, t);
  return l;
}

var J = "midnight",
    I = "noon",
    V = "morning",
    K = "afternoon",
    $ = "evening",
    Z = "night",
    ee = {
  G: function G(e, t, n) {
    var r = e.getUTCFullYear() > 0 ? 1 : 0;

    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, {
          width: "abbreviated"
        });

      case "GGGGG":
        return n.era(r, {
          width: "narrow"
        });

      case "GGGG":
      default:
        return n.era(r, {
          width: "wide"
        });
    }
  },
  y: function y(e, t, n) {
    if ("yo" === t) {
      var r = e.getUTCFullYear(),
          a = r > 0 ? r : 1 - r;
      return n.ordinalNumber(a, {
        unit: "year"
      });
    }

    return Y(e, t);
  },
  Y: function Y(e, t, n, r) {
    var a = G(e, r),
        o = a > 0 ? a : 1 - a;
    return "YY" === t ? U(o % 100, 2) : "Yo" === t ? n.ordinalNumber(o, {
      unit: "year"
    }) : U(o, t.length);
  },
  R: function R(e, t) {
    return U(B(e), t.length);
  },
  u: function u(e, t) {
    return U(e.getUTCFullYear(), t.length);
  },
  Q: function Q(e, t, n) {
    var r = Math.ceil((e.getUTCMonth() + 1) / 3);

    switch (t) {
      case "Q":
        return String(r);

      case "QQ":
        return U(r, 2);

      case "Qo":
        return n.ordinalNumber(r, {
          unit: "quarter"
        });

      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });

      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });

      case "QQQQ":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  q: function q(e, t, n) {
    var r = Math.ceil((e.getUTCMonth() + 1) / 3);

    switch (t) {
      case "q":
        return String(r);

      case "qq":
        return U(r, 2);

      case "qo":
        return n.ordinalNumber(r, {
          unit: "quarter"
        });

      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });

      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });

      case "qqqq":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  M: function M(e, t, n) {
    var r = e.getUTCMonth();

    switch (t) {
      case "M":
      case "MM":
        return j(e, t);

      case "Mo":
        return n.ordinalNumber(r + 1, {
          unit: "month"
        });

      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });

      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });

      case "MMMM":
      default:
        return n.month(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  L: function L(e, t, n) {
    var r = e.getUTCMonth();

    switch (t) {
      case "L":
        return String(r + 1);

      case "LL":
        return U(r + 1, 2);

      case "Lo":
        return n.ordinalNumber(r + 1, {
          unit: "month"
        });

      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });

      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });

      case "LLLL":
      default:
        return n.month(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  w: function w(e, t, n, r) {
    var a = function (e, t) {
      o(1, arguments);
      var n = i(e),
          r = A(n, t).getTime() - R(n, t).getTime();
      return Math.round(r / 6048e5) + 1;
    }(e, r);

    return "wo" === t ? n.ordinalNumber(a, {
      unit: "week"
    }) : U(a, t.length);
  },
  I: function I(e, t, n) {
    var r = function (e) {
      o(1, arguments);
      var t = i(e),
          n = X(t).getTime() - Q(t).getTime();
      return Math.round(n / 6048e5) + 1;
    }(e);

    return "Io" === t ? n.ordinalNumber(r, {
      unit: "week"
    }) : U(r, t.length);
  },
  d: function d(e, t, n) {
    return "do" === t ? n.ordinalNumber(e.getUTCDate(), {
      unit: "date"
    }) : F(e, t);
  },
  D: function D(e, t, n) {
    var r = function (e) {
      o(1, arguments);
      var t = i(e),
          n = t.getTime();
      t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
      var r = t.getTime(),
          a = n - r;
      return Math.floor(a / 864e5) + 1;
    }(e);

    return "Do" === t ? n.ordinalNumber(r, {
      unit: "dayOfYear"
    }) : U(r, t.length);
  },
  E: function E(e, t, n) {
    var r = e.getUTCDay();

    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });

      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });

      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });

      case "EEEE":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  e: function e(_e2, t, n, r) {
    var a = _e2.getUTCDay(),
        o = (a - r.weekStartsOn + 8) % 7 || 7;

    switch (t) {
      case "e":
        return String(o);

      case "ee":
        return U(o, 2);

      case "eo":
        return n.ordinalNumber(o, {
          unit: "day"
        });

      case "eee":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });

      case "eeeee":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });

      case "eeeeee":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });

      case "eeee":
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  c: function c(e, t, n, r) {
    var a = e.getUTCDay(),
        o = (a - r.weekStartsOn + 8) % 7 || 7;

    switch (t) {
      case "c":
        return String(o);

      case "cc":
        return U(o, t.length);

      case "co":
        return n.ordinalNumber(o, {
          unit: "day"
        });

      case "ccc":
        return n.day(a, {
          width: "abbreviated",
          context: "standalone"
        });

      case "ccccc":
        return n.day(a, {
          width: "narrow",
          context: "standalone"
        });

      case "cccccc":
        return n.day(a, {
          width: "short",
          context: "standalone"
        });

      case "cccc":
      default:
        return n.day(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  i: function i(e, t, n) {
    var r = e.getUTCDay(),
        a = 0 === r ? 7 : r;

    switch (t) {
      case "i":
        return String(a);

      case "ii":
        return U(a, t.length);

      case "io":
        return n.ordinalNumber(a, {
          unit: "day"
        });

      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });

      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });

      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });

      case "iiii":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  a: function a(e, t, n) {
    var r = e.getUTCHours() / 12 >= 1 ? "pm" : "am";

    switch (t) {
      case "a":
      case "aa":
      case "aaa":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });

      case "aaaaa":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });

      case "aaaa":
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  b: function b(e, t, n) {
    var r,
        a = e.getUTCHours();

    switch (r = 12 === a ? I : 0 === a ? J : a / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
      case "bbb":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });

      case "bbbbb":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });

      case "bbbb":
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  B: function B(e, t, n) {
    var r,
        a = e.getUTCHours();

    switch (r = a >= 17 ? $ : a >= 12 ? K : a >= 4 ? V : Z, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });

      case "BBBBB":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });

      case "BBBB":
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  h: function h(e, t, n) {
    if ("ho" === t) {
      var r = e.getUTCHours() % 12;
      return 0 === r && (r = 12), n.ordinalNumber(r, {
        unit: "hour"
      });
    }

    return q(e, t);
  },
  H: function H(e, t, n) {
    return "Ho" === t ? n.ordinalNumber(e.getUTCHours(), {
      unit: "hour"
    }) : _H(e, t);
  },
  K: function K(e, t, n) {
    var r = e.getUTCHours() % 12;
    return "Ko" === t ? n.ordinalNumber(r, {
      unit: "hour"
    }) : U(r, t.length);
  },
  k: function k(e, t, n) {
    var r = e.getUTCHours();
    return 0 === r && (r = 24), "ko" === t ? n.ordinalNumber(r, {
      unit: "hour"
    }) : U(r, t.length);
  },
  m: function m(e, t, n) {
    return "mo" === t ? n.ordinalNumber(e.getUTCMinutes(), {
      unit: "minute"
    }) : _(e, t);
  },
  s: function s(e, t, n) {
    return "so" === t ? n.ordinalNumber(e.getUTCSeconds(), {
      unit: "second"
    }) : L(e, t);
  },
  S: function S(e, t) {
    return z(e, t);
  },
  X: function X(e, t, n, r) {
    var a = (r._originalDate || e).getTimezoneOffset();
    if (0 === a) return "Z";

    switch (t) {
      case "X":
        return ne(a);

      case "XXXX":
      case "XX":
        return re(a);

      case "XXXXX":
      case "XXX":
      default:
        return re(a, ":");
    }
  },
  x: function x(e, t, n, r) {
    var a = (r._originalDate || e).getTimezoneOffset();

    switch (t) {
      case "x":
        return ne(a);

      case "xxxx":
      case "xx":
        return re(a);

      case "xxxxx":
      case "xxx":
      default:
        return re(a, ":");
    }
  },
  O: function O(e, t, n, r) {
    var a = (r._originalDate || e).getTimezoneOffset();

    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + te(a, ":");

      case "OOOO":
      default:
        return "GMT" + re(a, ":");
    }
  },
  z: function z(e, t, n, r) {
    var a = (r._originalDate || e).getTimezoneOffset();

    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + te(a, ":");

      case "zzzz":
      default:
        return "GMT" + re(a, ":");
    }
  },
  t: function t(e, _t, n, r) {
    var a = r._originalDate || e;
    return U(Math.floor(a.getTime() / 1e3), _t.length);
  },
  T: function T(e, t, n, r) {
    return U((r._originalDate || e).getTime(), t.length);
  }
};

function te(e, t) {
  var n = e > 0 ? "-" : "+",
      r = Math.abs(e),
      a = Math.floor(r / 60),
      o = r % 60;
  if (0 === o) return n + String(a);
  var i = t || "";
  return n + String(a) + i + U(o, 2);
}

function ne(e, t) {
  return e % 60 == 0 ? (e > 0 ? "-" : "+") + U(Math.abs(e) / 60, 2) : re(e, t);
}

function re(e, t) {
  var n = t || "",
      r = e > 0 ? "-" : "+",
      a = Math.abs(e);
  return r + U(Math.floor(a / 60), 2) + n + U(a % 60, 2);
}

function ae(e, t) {
  switch (e) {
    case "P":
      return t.date({
        width: "short"
      });

    case "PP":
      return t.date({
        width: "medium"
      });

    case "PPP":
      return t.date({
        width: "long"
      });

    case "PPPP":
    default:
      return t.date({
        width: "full"
      });
  }
}

function oe(e, t) {
  switch (e) {
    case "p":
      return t.time({
        width: "short"
      });

    case "pp":
      return t.time({
        width: "medium"
      });

    case "ppp":
      return t.time({
        width: "long"
      });

    case "pppp":
    default:
      return t.time({
        width: "full"
      });
  }
}

var ie = {
  p: oe,
  P: function P(e, t) {
    var n,
        r = e.match(/(P+)(p+)?/),
        a = r[1],
        o = r[2];
    if (!o) return ae(e, t);

    switch (a) {
      case "P":
        n = t.dateTime({
          width: "short"
        });
        break;

      case "PP":
        n = t.dateTime({
          width: "medium"
        });
        break;

      case "PPP":
        n = t.dateTime({
          width: "long"
        });
        break;

      case "PPPP":
      default:
        n = t.dateTime({
          width: "full"
        });
    }

    return n.replace("{{date}}", ae(a, t)).replace("{{time}}", oe(o, t));
  }
},
    ue = ["D", "DD"],
    se = ["YY", "YYYY"];

function ce(e) {
  return -1 !== ue.indexOf(e);
}

function de(e) {
  return -1 !== se.indexOf(e);
}

function le(e, t, n) {
  if ("YYYY" === e) throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(t, "`) for formatting years to the input `").concat(n, "`; see: https://git.io/fxCyr"));
  if ("YY" === e) throw new RangeError("Use `yy` instead of `YY` (in `".concat(t, "`) for formatting years to the input `").concat(n, "`; see: https://git.io/fxCyr"));
  if ("D" === e) throw new RangeError("Use `d` instead of `D` (in `".concat(t, "`) for formatting days of the month to the input `").concat(n, "`; see: https://git.io/fxCyr"));
  if ("DD" === e) throw new RangeError("Use `dd` instead of `DD` (in `".concat(t, "`) for formatting days of the month to the input `").concat(n, "`; see: https://git.io/fxCyr"));
}

var fe = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g,
    he = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g,
    me = /^'([^]*?)'?$/,
    ge = /''/g,
    ve = /[a-zA-Z]/;

function we(e, t, n) {
  o(2, arguments);
  var r = String(t),
      u = n || {},
      s = u.locale || E,
      c = s.options && s.options.firstWeekContainsDate,
      d = null == c ? 1 : a(c),
      l = null == u.firstWeekContainsDate ? d : a(u.firstWeekContainsDate);
  if (!(l >= 1 && l <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var h = s.options && s.options.weekStartsOn,
      m = null == h ? 0 : a(h),
      g = null == u.weekStartsOn ? m : a(u.weekStartsOn);
  if (!(g >= 0 && g <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!s.localize) throw new RangeError("locale must contain localize property");
  if (!s.formatLong) throw new RangeError("locale must contain formatLong property");
  var w = i(e);
  if (!v(w)) throw new RangeError("Invalid time value");
  var b = f(w),
      y = O(w, b),
      p = {
    firstWeekContainsDate: l,
    weekStartsOn: g,
    locale: s,
    _originalDate: w
  },
      k = r.match(he).map(function (e) {
    var t = e[0];
    return "p" === t || "P" === t ? (0, ie[t])(e, s.formatLong, p) : e;
  }).join("").match(fe).map(function (n) {
    if ("''" === n) return "'";
    var r = n[0];
    if ("'" === r) return be(n);
    var a = ee[r];
    if (a) return !u.useAdditionalWeekYearTokens && de(n) && le(n, t, e), !u.useAdditionalDayOfYearTokens && ce(n) && le(n, t, e), a(y, n, s.localize, p);
    if (r.match(ve)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + r + "`");
    return n;
  }).join("");
  return k;
}

function be(e) {
  return e.match(me)[1].replace(ge, "'");
}

function ye(e) {
  o(1, arguments);
  var t = i(e),
      n = t.getMonth();
  return n;
}

function pe(e) {
  o(1, arguments);
  var t = i(e),
      n = t.getTime();
  return n;
}

function ke(e) {
  return o(1, arguments), Math.floor(pe(e) / 1e3);
}

function Me(e, t) {
  o(1, arguments);
  var n = i(e),
      r = n.getFullYear(),
      u = t || {},
      s = u.locale,
      c = s && s.options && s.options.firstWeekContainsDate,
      l = null == c ? 1 : a(c),
      f = null == u.firstWeekContainsDate ? l : a(u.firstWeekContainsDate);
  if (!(f >= 1 && f <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var h = new Date(0);
  h.setFullYear(r + 1, 0, f), h.setHours(0, 0, 0, 0);
  var m = d(h, t),
      g = new Date(0);
  g.setFullYear(r, 0, f), g.setHours(0, 0, 0, 0);
  var v = d(g, t);
  return n.getTime() >= m.getTime() ? r + 1 : n.getTime() >= v.getTime() ? r : r - 1;
}

function Te(e, t) {
  o(1, arguments);
  var n = t || {},
      r = n.locale,
      i = r && r.options && r.options.firstWeekContainsDate,
      u = null == i ? 1 : a(i),
      s = null == n.firstWeekContainsDate ? u : a(n.firstWeekContainsDate),
      c = Me(e, t),
      l = new Date(0);
  l.setFullYear(c, 0, s), l.setHours(0, 0, 0, 0);
  var f = d(l, t);
  return f;
}

function Ne(e, t) {
  o(1, arguments);
  var n = i(e),
      r = d(n, t).getTime() - Te(n, t).getTime();
  return Math.round(r / 6048e5) + 1;
}

function De(e) {
  o(1, arguments);
  var t = i(e),
      n = t.getMonth();
  return t.setFullYear(t.getFullYear(), n + 1, 0), t.setHours(0, 0, 0, 0), t;
}

function Ce(e) {
  var t = e.locale,
      n = e.showWeekNumber,
      a = e.dayPickerProps,
      o = a.classNames,
      i = void 0 === o ? {} : o,
      s = a.styles,
      c = void 0 === s ? {} : s,
      l = a.formatWeekdayName,
      f = a.block.weekdayNames || function (e) {
    for (var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : function () {}, n = d(new Date(), {
      locale: e
    }), r = [], a = 0; a < 7; a++) {
      var o = u(n, a);
      r.push(t(o, {
        locale: e
      }));
    }

    return r;
  }(t, l);

  return r.createElement("thead", {
    style: c.head,
    className: i.head
  }, r.createElement("tr", {
    style: c.headRow,
    className: i.headRow
  }, n && r.createElement("th", {
    style: c.headWeekNumber,
    className: i.headWeekNumber
  }), f.map(function (e, t) {
    return r.createElement("th", {
      key: t,
      scope: "col",
      style: c.headWeekName,
      className: i.headWeekName
    }, e);
  })));
}

function Pe(e) {
  var t = e.weekNumber,
      n = e.week,
      a = e.currentMonth,
      o = e.dayPickerProps,
      i = o.showWeekNumber,
      u = o.classNames,
      s = void 0 === u ? {} : u,
      c = o.styles,
      d = void 0 === c ? {} : c,
      l = o.components,
      f = l.Day,
      h = l.WeekNumber;
  return r.createElement("tr", {
    className: s.week,
    style: d.week
  }, i && r.createElement("th", {
    className: s.weekWeeknumber,
    style: d.weekWeeknumber
  }, r.createElement(h, {
    days: n,
    number: Number(t),
    dayPickerProps: o
  })), n.map(function (e) {
    return r.createElement("td", {
      className: s.weekDay,
      style: d.weekDay,
      key: ke(e)
    }, r.createElement(f, {
      day: e,
      dayPickerProps: o,
      currentMonth: a
    }));
  }));
}

function xe(e, t) {
  for (var n = [], r = d(e, {
    locale: t.locale
  }), a = k(e, r), o = 0; o < a; o++) {
    var i = u(r, o);
    n.push(i);
  }

  return n;
}

function We(e, t) {
  for (var n = [], r = k(function (e, t) {
    o(1, arguments);
    var n = t || {},
        r = n.locale,
        u = r && r.options && r.options.weekStartsOn,
        s = null == u ? 0 : a(u),
        c = null == n.weekStartsOn ? s : a(n.weekStartsOn);
    if (!(c >= 0 && c <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var d = i(e),
        l = d.getDay(),
        f = 6 + (l < c ? -7 : 0) - (l - c);
    return d.setDate(d.getDate() + f), d.setHours(23, 59, 59, 999), d;
  }(e, {
    locale: t.locale
  }), e), s = 1; s <= r; s++) {
    var c = u(e, s);
    n.push(c);
  }

  return n;
}

function Se(e, t) {
  for (var n = t.locale, r = t.fixedWeeks, i = M(e), s = k(T(e), i), c = {}, d = "", l = 0; l <= s; l++) {
    var f = u(i, l),
        h = Ne(f, {
      locale: n
    });
    1 === h && 11 === ye(f) && (h = 53);
    var m = h.toString();

    if (!c[m]) {
      var g = xe(f, t);
      c[m] = g;
    }

    c[m].push(f), d = m;
  }

  var v = c[d],
      w = We(v[v.length - 1], t);

  if (c[d] = v.concat(w), r) {
    var b = (v = c[d])[v.length - 1],
        p = function (e, t) {
      return o(1, arguments), y(De(e), M(e), t) + 1;
    }(e, {
      locale: n
    });

    if (p < 6) for (var N = k(function (e, t) {
      o(2, arguments);
      var n = a(t),
          r = 7 * n;
      return u(e, r);
    }(b, 6 - p), b), D = 0; D < N; D++) {
      var C = u(b, D + 1),
          P = Ne(C, {
        locale: n
      });
      1 === P && 11 === ye(e) && (P = 53), c[P] || (c[P] = []), c[P.toString()].push(C);
    }
  }

  return c;
}

function Ee(e) {
  var t = e.month,
      n = e.dayPickerProps,
      a = n.locale,
      o = n.classNames,
      i = void 0 === o ? {} : o,
      u = n.styles,
      s = void 0 === u ? {} : u,
      c = n.showCaption,
      d = n.showHead,
      l = n.components,
      f = (void 0 === l ? {} : l).MonthCaption,
      h = Se(t, n);
  return r.createElement("div", {
    className: i.month
  }, r.createElement("table", {
    className: i.monthTable,
    style: s.monthTable
  }, c && r.createElement(f, {
    month: t,
    dayPickerProps: n
  }), d && r.createElement(Ce, {
    locale: a,
    showWeekNumber: n.showWeekNumber,
    dayPickerProps: n
  }), r.createElement("tbody", {
    className: i.monthTbody,
    style: s.monthTbody
  }, Object.keys(h).map(function (e) {
    return r.createElement(Pe, {
      currentMonth: t,
      key: e,
      week: h[e],
      weekNumber: Number(e),
      dayPickerProps: n
    });
  }))));
}

function Oe(e) {
  for (var t = e.month, n = void 0 === t ? new Date() : t, r = e.numberOfMonths, a = void 0 === r ? 1 : r, u = e.toMonth, c = e.fromMonth, d = e.reverseMonths, l = M(n), f = function (e, t) {
    o(2, arguments);
    var n = i(e),
        r = i(t),
        a = g(n, r),
        u = Math.abs(b(n, r));
    n.setMonth(n.getMonth() - a * u);
    var s = g(n, r) === -a,
        c = a * (u - s);
    return 0 === c ? 0 : c;
  }(M(s(l, a)), l), h = [], m = 0; m < f; m++) {
    var v = s(l, m);
    u && v > M(u) || c && v < M(c) || h.push(v);
  }

  return d && (h = h.reverse()), h;
}

var Ue = {
  disabled: !1,
  hidden: !1,
  interactive: !0,
  aftermonth: !1,
  beforemonth: !1,
  selected: !1,
  today: !1
};

function Ye(e, t) {
  return k(e, t) > 0;
}

function je(e, t) {
  return k(e, t) < 0;
}

function Fe(e, t) {
  return !!t && (Array.isArray(t) ? t : [t]).some(function (t) {
    return !!t && (function (e, t) {
      return t instanceof Date && w(e, t);
    }(e, t) || function (e, t) {
      if (!("from" in t && "to" in t)) return !1;
      var n = {
        from: t.from,
        to: t.to
      };
      return !(k(n.from, n.to) <= 0) && je(e, t.to) && Ye(e, t.from);
    }(e, t) || function (e, t) {
      return !("after" in t) && "before" in t && je(e, {
        before: t.before
      }.before);
    }(e, t) || function (e, t) {
      return !("before" in t) && "after" in t && Ye(e, {
        after: t.after
      }.after);
    }(e, t) || function (e, t) {
      if (!("after" in t && "before" in t)) return !1;
      var n = {
        before: t.before,
        after: t.after
      };
      return !(k(n.before, n.after) <= 0) && Ye(e, t.after) && je(e, t.before);
    }(e, t) || function (e, t) {
      return "daysOfWeek" in t && t.daysOfWeek.includes(e.getDay());
    }(e, t) || function (e, t) {
      return t instanceof Function && t(e);
    }(e, t));
  });
}

function qe(e, t) {
  return Object.keys(t).reduce(function (e, t) {
    return function (n, r) {
      var a = t[r];
      return Fe(e, a) && n.push(r), n;
    };
  }(e, t), []);
}

function He(e, t) {
  return function (e, t) {
    o(2, arguments);
    var n = i(e),
        r = i(t);
    return n.getTime() < r.getTime();
  }(e, M(t)) ? "beforemonth" : function (e, t) {
    o(2, arguments);
    var n = i(e),
        r = i(t);
    return n.getTime() > r.getTime();
  }(e, T(t)) ? "aftermonth" : void 0;
}

function _e(e, n, r) {
  var a = t._objectSpread2({}, Ue);

  a.today = function (e) {
    return o(1, arguments), w(e, Date.now());
  }(e);

  var i = He(e, n);
  i && (a[i] = !0);
  var u = a.beforemonth || a.aftermonth;
  return a.hidden = u && !r.showOutsideDays, a.disabled = u && !r.enableOutsideDaysClick, qe(e, function (e) {
    var n = t._objectSpread2({}, e.days);

    return e.selected && (n.selected = e.selected), e.disabled && (n.disabled = e.disabled), e.hidden && (n.hidden = e.hidden), n;
  }(r)).forEach(function (e) {
    return a[e] = !0;
  }), (!r.onDayClick || a.hidden || a.disabled) && (a.interactive = !1), a;
}

var Le = {
  enableOutsideDaysClick: !1,
  classNames: {
    root: "rdp",
    caption: "rdp-caption",
    day: "rdp-day",
    dayWrapper: "rdp-day_wrapper",
    month: "rdp-month",
    monthTable: "rdp-month_table",
    monthTbody: "rdp-month_tbody",
    months: "rdp-months",
    head: "rdp-head",
    headRow: "rdp-head_row",
    headWeekNumber: "rdp-head_weeknumber",
    headWeekName: "rdp-head_weekname",
    nav: "rdp-nav",
    navPrev: "rdp-nav_prev",
    navNext: "rdp-nav_next",
    week: "rdp-week",
    weekDay: "rdp-week_day",
    weekWeeknumber: "rdp-week_weeknumber",
    weekNumber: "rdp-weeknumber",
    selected: "rdp-day_selected",
    disabled: "rdp-day_disabled",
    today: "rdp-day_today",
    aftermonth: "rdp-day_outside",
    beforemonth: "rdp-day_outside"
  },
  className: "",
  style: {},
  styles: {},
  components: {
    MonthCaption: function MonthCaption(e) {
      var t = e.dayPickerProps,
          n = e.month,
          a = function (e) {
        var t = e.styles,
            n = void 0 === t ? {} : t,
            r = e.classNames;
        return {
          containerProps: {
            className: (void 0 === r ? {} : r).caption,
            style: n.caption
          }
        };
      }(t).containerProps,
          o = t.locale,
          i = t.formatCaption,
          u = void 0 === i ? function () {} : i,
          s = t.block,
          c = s.customMonths ? "".concat(s.customMonths[new Date(n).getMonth()], " ").concat(new Date(n).getFullYear()) : u(n, {
        locale: o
      });

      return r.createElement("caption", a, c);
    },
    Day: function Day(e) {
      var n = e.day,
          a = e.dayPickerProps,
          o = e.currentMonth,
          i = a.locale,
          u = a.formatDay,
          s = void 0 === u ? function () {} : u,
          c = _e(n, o, a);

      if (c.hidden) return r.createElement("span", {
        "aria-hidden": !0
      });

      var d = function (e, n, r) {
        var a,
            o = r.classNames,
            i = void 0 === o ? {} : o,
            u = r.daysClassNames,
            s = r.daysStyles,
            c = r.onDayClick,
            d = r.styles,
            l = void 0 === d ? {} : d;
        n.interactive && c && (a = function a(t) {
          t.stopPropagation(), t.preventDefault(), c(e, n, t);
        });

        var f = t._objectSpread2({}, l.day);

        l && Object.keys(n).forEach(function (e) {
          f = t._objectSpread2({}, f, {}, l[e]);
        }), s && Object.keys(n).forEach(function (e) {
          f = t._objectSpread2({}, f, {}, s[e]);
        });
        var h = [];
        i && i.day && (h.push(i.day), u && Object.keys(n).filter(function (e) {
          return !!n[e];
        }).forEach(function (e) {
          e && i[e] && h.push(i[e]), u && u[e] && h.push(u[e]);
        }));
        var m = {};
        return Object.entries(n).filter(function (e) {
          return Boolean(e);
        }).forEach(function (e) {
          var n = t._slicedToArray(e, 2),
              r = n[0],
              a = n[1];

          m["data-rdp-".concat(r)] = a;
        }), {
          containerProps: t._objectSpread2({
            "aria-disabled": !n.interactive || void 0,
            "aria-hidden": !n.hidden || void 0,
            disabled: Boolean(n.disabled) || void 0,
            onClick: a,
            style: f,
            className: h.join(" ")
          }, m),
          wrapperProps: {
            className: i.dayWrapper,
            styles: l.dayWrapper
          },
          modifiers: n
        };
      }(n, c, a),
          l = d.containerProps,
          f = d.wrapperProps,
          h = c.interactive ? "button" : "span";

      return r.createElement(h, l, r.createElement("span", f, s(n, {
        locale: i
      })));
    },
    Navigation: function Navigation(e) {
      var t = e.dayPickerProps,
          n = t.onMonthChange,
          a = t.onPrevClick,
          o = t.onNextClick,
          i = function (e) {
        var t,
            n,
            r = e.fromMonth,
            a = e.toMonth,
            o = e.month,
            i = e.numberOfMonths,
            u = void 0 === i ? 1 : i,
            c = e.pagedNavigation ? u : 1,
            d = M(o || new Date());
        return (!r || d > M(r)) && (t = s(d, -1 * c)), (!a || s(d, u) <= M(a)) && (n = s(d, c)), {
          nextMonth: n,
          prevMonth: t
        };
      }(t),
          u = i.nextMonth,
          c = i.prevMonth,
          d = function (e) {
        var t = e.classNames,
            n = void 0 === t ? {} : t,
            r = e.styles,
            a = void 0 === r ? {} : r;
        return {
          containerProps: {
            className: n.nav,
            style: a.nav
          },
          nextProps: {
            className: n.navNext,
            style: a.navNext
          },
          prevProps: {
            className: n.navPrev,
            style: a.navPrev
          }
        };
      }(t),
          l = d.containerProps,
          f = d.nextProps,
          h = d.prevProps,
          m = t.prevLabel,
          g = t.nextLabel,
          v = [m && r.createElement("button", Object.assign({}, h, {
        key: "prev",
        disabled: !c,
        type: "button",
        onClick: function onClick(e) {
          c && (n && n(c, e), a && a(c, e));
        }
      }), m), g && r.createElement("button", Object.assign({}, f, {
        key: "next",
        disabled: !u,
        type: "button",
        onClick: function onClick(e) {
          u && (n && n(u, e), o && o(u, e));
        }
      }), g)];

      return "rtl" === t.dir && (v = v.reverse()), r.createElement("div", l, v);
    },
    WeekNumber: function WeekNumber(e) {
      var t = e.dayPickerProps,
          n = e.number,
          a = t.formatWeekNumber,
          o = t.locale,
          i = t.classNames,
          u = void 0 === i ? {} : i,
          s = t.styles,
          c = void 0 === s ? {} : s;
      return r.createElement("span", {
        className: u.weekNumber,
        style: c.weekNumber
      }, a && a(n, {
        locale: o
      }));
    }
  },
  fixedWeeks: !1,
  formatCaption: function formatCaption(e, t) {
    return we(e, "LLLL Y", t);
  },
  formatDay: function formatDay(e, t) {
    return we(e, "d", t);
  },
  formatWeekdayName: function formatWeekdayName(e, t) {
    return we(e, "E", t);
  },
  formatWeekNumber: function formatWeekNumber(e) {
    return "".concat(e);
  },
  locale: E,
  nextLabel: "▶",
  daysClassNames: {},
  daysStyles: {},
  month: M(new Date()),
  numberOfMonths: 1,
  pagedNavigation: !1,
  prevLabel: "◀",
  reverseMonths: !1,
  showCaption: !0,
  showHead: !0,
  showNavigation: !0,
  showOutsideDays: !1,
  showWeekNumber: !1
};

function ze(e) {
  var n = t._objectSpread2({}, Le.components, {}, e.components),
      a = t._objectSpread2({}, Le.classNames, {}, e.classNames),
      o = t._objectSpread2({}, Le, {}, function (e) {
    if (!e) return {};
    var n = {};
    return Object.entries(e).forEach(function (e) {
      var r = t._slicedToArray(e, 2),
          a = r[0],
          o = r[1];

      void 0 !== o && (n[a.toString()] = o);
    }), n;
  }(e), {
    components: n,
    classNames: a
  }),
      i = o.styles,
      u = t._objectSpread2({}, i && i.root || {}, {}, o.style),
      s = [o.classNames ? o.classNames.root : ""];

  o.className && s.concat(o.className.split(" "));
  var c = Oe(o),
      d = o.components && o.components.Navigation;
  return r.createElement("div", {
    className: s.join(" "),
    style: u,
    dir: o.dir
  }, o.showNavigation && o.onMonthChange && r.createElement(d, {
    dayPickerProps: o
  }), r.createElement("div", {
    className: o.classNames && o.classNames.months,
    style: o.styles ? o.styles.month : void 0
  }, c.map(function (e) {
    return r.createElement(Ee, {
      key: pe(e),
      month: e,
      dayPickerProps: o
    });
  })));
}

exports.default = function () {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Le,
      n = Boolean(e.month),
      a = r.useState(M(e.initialMonth || new Date())),
      o = t._slicedToArray(a, 2),
      i = o[0],
      u = o[1];

  function s(t, n) {
    u(t), e.onMonthChange && e.onMonthChange(t, n);
  }

  return r.createElement(ze, Object.assign({}, e, {
    onMonthChange: n ? e.onMonthChange : s,
    month: n ? e.month : i
  }));
};